import { Avatar as AntAvatar } from 'antd';
import { cn } from '@shared/lib/cn';

const PALETTE = [
  '#3b82f6',
  '#10b981',
  '#f59e0b',
  '#8b5cf6',
  '#ec4899',
  '#06b6d4',
  '#f97316',
  '#f43f5e',
];

function hashIndex(seed: string): number {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return h % PALETTE.length;
}

interface AvatarProps {
  seed: string;
  initials: string;
  /** Optional image URL — falls back to colored initials if missing/fails. */
  src?: string;
  size?: 'xs' | 'sm' | 'md';
  inactive?: boolean;
  className?: string;
}

const SIZE_PX: Record<NonNullable<AvatarProps['size']>, number> = {
  xs: 20,
  sm: 28,
  md: 36,
};

export function Avatar({ seed, initials, src, size = 'sm', inactive, className }: AvatarProps) {
  const color = PALETTE[hashIndex(seed)];
  const px = SIZE_PX[size];
  return (
    <AntAvatar
      size={px}
      shape="circle"
      src={src ?? undefined}
      className={cn(inactive && 'opacity-50 grayscale', className)}
      style={{
        backgroundColor: src ? undefined : color,
        fontWeight: 600,
        fontSize: px <= 20 ? 10 : 12,
      }}
    >
      {initials.slice(0, 2).toUpperCase()}
    </AntAvatar>
  );
}
